import { defaultNS, useTranslation } from '@/lib/i18n';

/**
 * 共通(common)の翻訳キーを使用するためのカスタムフック。
 *
 * @returns {Function} - 翻訳関数`t`を返す
 */
export const useCommonTranslation = () => {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: 'common',
  });
  return t;
};
